import styled from '@emotion/styled'
import { colors } from 'Constants'

export default styled.div`
  width: ${({ width }) => width ?? '100px'};
  height: ${({ height }) => height ?? '2px'};
  background-color: ${({ color }) => color ?? colors.backgroundInverted};
  align-self: center;
`
